// extracted by extract-css-chunks-webpack-plugin
module.exports = {"logo":"logo-23zjadIy"};